'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalTrigger = function ModalTrigger(props) {
  return _react2.default.createElement(_.Button, props);
};

exports.default = ModalTrigger;


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Modal/ModalTrigger.js